import React, { useState } from "react";
import { Badge, Spinner, Button, Alert, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ICON_SEARCH,
  ICON_CANCEL,
  ICON_PREV_ALT,
  ICON_NEXT_ALT,
  ICON_FIRST_PAGE,
  ICON_LAST_PAGE,
} from "../extras/icons";
import { useDispatch, useSelector } from "react-redux";
import { listAudiencesAction } from "../../actions/audiencesActions";
import { useEffect } from "react";
import FilterModal from "./list/FilterModal";
import AudienceCard from "./list/AudienceCard";
import es from "../../lang/es";

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const AudienceList = () => {
  const initialPage = 0;
  const initialPageSize = 20;
  const initialFilter = {
    fechaSolicitudDesde: "",
    fechaSolicitudHasta: "",
    fechaInicioDesde: "",
    fechaInicioHasta: "",
    fechaVencimientoDesde: "",
    fechaVencimientoHasta: "",
    vencimientoIPPDesde: "",
    vencimientoIPPHasta: "",
    numero: "",
    id: "",
    caratula: "",
    fiscalia: "",
    tipo: "",
    estado: "",
    sala: "",
    solicitante: "",
    operador: "",
    juez: "",
    ofiju: "",
    categoria: "",
  };

  const dispatch = useDispatch();

  const [pageSize, setPageSize] = useState(initialPageSize);
  const [showFilter, setShowFilter] = useState(false);
  const [filterParams, setFilterParams] = useState({});
  const [filters, setFilters] = useState([]);
  const [filter, setFilter] = useState(initialFilter);

  const audiencesStore = useSelector((state) => state.audiences.audiences);
  const audiencesLoading = useSelector((state) => state.audiences.loading);
  const isLast = useSelector((state) => state.audiences.isLast);
  const isFirst = useSelector((state) => state.audiences.isFirst);
  const total = useSelector((state) => state.audiences.total);
  const totalPages = useSelector((state) => state.audiences.totalPages);
  const actualPage = useSelector((state) => state.audiences.actualPage);

  useEffect(() => {
    dispatch(listAudiencesAction({ page: initialPage, size: initialPageSize }));
  }, []);

  const buildParams = (page, size, fp) => ({ page, size, ...fp });

  const handleFirst = () => {
    dispatch(listAudiencesAction(buildParams(0, pageSize, filterParams)));
  };

  const handlePrev = () => {
    dispatch(listAudiencesAction(buildParams(actualPage - 1, pageSize, filterParams)));
  };

  const handleNext = () => {
    dispatch(listAudiencesAction(buildParams(actualPage + 1, pageSize, filterParams)));
  };

  const handleLast = () => {
    dispatch(listAudiencesAction(buildParams(totalPages - 1, pageSize, filterParams)));
  };

  const handleSizeChange = (e) => {
    const newSize = Math.min(parseInt(e.target.value, 10), 100);
    setPageSize(newSize);
    dispatch(listAudiencesAction(buildParams(0, newSize, filterParams)));
  };

  const handleOpenFilter = () => setShowFilter(true);
  const handleCloseFilter = () => setShowFilter(false);

  const handleRemoveFilter = (e) => {
    e.preventDefault();
    setFilterParams({});
    setFilters([]);
    setFilter(initialFilter);
    dispatch(listAudiencesAction({ page: initialPage, size: pageSize }));
  };

  const hasFilters = Object.keys(filterParams).length > 0;

  return (
    <div className="row">
      <div className="col-12">
        <div className="card shadow mb-4">
          <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
            <h6 className="m-0 font-weight-bold text-primary">LISTADO</h6>
            <div className="dropdown no-arrow">
              <Button
                variant="outline-secondary"
                size="sm"
                className="float-right"
                onClick={handleOpenFilter}
              >
                <ICON_SEARCH />
              </Button>

              <FilterModal
                show={showFilter}
                handleClose={handleCloseFilter}
                initialPage={initialPage}
                pageSize={pageSize}
                setFilterParams={setFilterParams}
                setFilters={setFilters}
                filter={filter}
                setFilter={setFilter}
              />
            </div>
          </div>
          <div className="card-body">
            {audiencesLoading ? (
              <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : audiencesStore ? (
              <React.Fragment>
                {hasFilters ? (
                  <div className="row">
                    <div className="col-md-10 mb-2">
                      <strong>Filtrado por: </strong>
                      <i>
                        {filters.map((f, index) =>
                          index > 0
                            ? `, ${f.campo}: ${f.valor}`
                            : `${f.campo}: ${f.valor}`
                        )}
                      </i>
                    </div>
                    <div className="col-md-2 mb-2">
                      <Button
                        variant="warning"
                        block
                        onClick={handleRemoveFilter}
                      >
                        <ICON_CANCEL /> {es.REMOVE_FILTERS}
                      </Button>
                    </div>
                  </div>
                ) : null}
                {audiencesStore.length > 0 ? (
                  <React.Fragment>
                    {audiencesStore.map((audience) => (
                      <div className="row" key={`alc${audience.id}`}>
                        <AudienceCard
                          key={`audience${audience.id}`}
                          audience={audience}
                        />
                      </div>
                    ))}
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <div className="d-flex align-items-center">
                        <span className="mr-2 text-muted small">Mostrar</span>
                        <Form.Control
                          as="select"
                          size="sm"
                          value={pageSize}
                          onChange={handleSizeChange}
                          style={{ width: "auto" }}
                        >
                          {PAGE_SIZE_OPTIONS.map((opt) => (
                            <option key={opt} value={opt}>
                              {opt} registros
                            </option>
                          ))}
                        </Form.Control>
                      </div>
                      <div className="d-flex align-items-center">
                        <Button
                          className="btn-circle mr-1"
                          variant="outline-primary"
                          onClick={handleFirst}
                          disabled={isFirst}
                          title="Primera página"
                        >
                          <ICON_FIRST_PAGE />
                        </Button>
                        <Button
                          className="btn-circle mr-2"
                          variant="primary"
                          onClick={handlePrev}
                          disabled={isFirst}
                        >
                          <ICON_PREV_ALT />
                        </Button>
                        <Button variant="primary" disabled={true}>
                          {actualPage + 1} de {totalPages}
                        </Button>
                        <Button
                          className="btn-circle ml-2"
                          variant="primary"
                          onClick={handleNext}
                          disabled={isLast}
                        >
                          <ICON_NEXT_ALT />
                        </Button>
                        <Button
                          className="btn-circle ml-1"
                          variant="outline-primary"
                          onClick={handleLast}
                          disabled={isLast}
                          title="Última página"
                        >
                          <ICON_LAST_PAGE />
                        </Button>
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  <Alert variant="info">
                    Por el momento no hay audiencias asociadas a su usuario
                  </Alert>
                )}
              </React.Fragment>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudienceList;
